/* components/CollectionFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref() group!: HTMLElement[];
    @Ref() closeFilters!: HTMLButtonElement[];
    @Ref() filter!: HTMLInputElement[];
    @Ref() apply!: HTMLInputElement[];

    init() {
        this.setEventListeners();

        // Show filter options
        this.handleGroupOpen(this.group);

        // Close filter menu
        this.closeFilterMenu(this.closeFilters);
    }

    setEventListeners() {
        for (const filter of this.filter) {
            this.$listen(filter, 'change', () => {
                if (window.innerWidth < 768) { return; }
                // eslint-disable-next-line max-len
                const submit:HTMLButtonElement|null|undefined = filter.closest('.collection-filters__group')?.querySelector('[data-ref="apply"]');
                submit?.click();
            });
        }
    }

    private handleGroupOpen(groups: HTMLElement[]) {
        for (const group of groups) {
            this.$listen(group, 'click', (event) => {

                // Do not continue for child clicks
                const clickedElement = event.target as HTMLElement;
                const groupOptions = group.querySelector('.collection-filters__group-options');
                if (groupOptions && (clickedElement == groupOptions || groupOptions.contains(clickedElement))) {
                    return;
                }

                for (const sibling of groups) {
                    if (group !== sibling) {
                        sibling.classList.remove('collection-filters__group--open');
                    }
                }
                group.classList.toggle('collection-filters__group--open');
            });
        }
    }

    private closeFilterMenu(closeFilters: HTMLButtonElement[]) {
        for (const closeFilter of closeFilters) {
            this.$listen(closeFilter, 'click', () => {

                // Only run if filters are active
                if (!document.body.classList.contains('collection-filters-active')) {
                    return;
                }

                // Body class
                document.body.classList.remove('collection-filters-active');

                // Filters class
                this.classList.remove('collection-filters--active');
            });
        }
    }
}
